// FAQ answers carry the odd internal link, written in markdown form:
// [ankertekst](/pad). The rendered copy turns those into <Link>, the schema.org
// copy needs them flattened back to plain text.
export const INLINE_LINK = /\[([^\]]+)\]\(([^)]+)\)/g;

export function stripInlineLinks(text: string) {
  return text.replace(INLINE_LINK, "$1");
}
